module.exports = __webpack_public_path__ + "img/san-3.1df8c017.jpeg";